import { useState } from 'react';
import { Checkbox } from '@lk-gtcom/ecomlab-components';
import { ButtonWithIcon } from '../../Buttons/ButtonWithIcon/ButtonWithIcon';
import check_icon from './img/bx-check.svg'
import delete_icon from './img/trash_icon.svg'
import edit_icon from './img/edit_icon.svg'
import calendar from './img/calendar.svg'
import { SingleDatePicker } from '../../SingleDatePicker/SingleDatePicker';
import dayjs from 'dayjs';

const SubtaskItem = ({
    title,
    row_id,
    checkbox,
    date,
    fetchEditRow,
    fetchDeleteRow,
    authorEmail,
    email
}) => {
    const [isEdit, setIsEdit] = useState(false);
    const [value, setValue] = useState(title);
    const [endDateTask, setEndDateTask] = useState(date ? new Date(date) : new Date());
    const [isDate, setIsDate] = useState(false)

    return (
        <div className="subtasks-list__item">
            <Checkbox
                green
                value={checkbox}
                onChange={(e) =>
                    fetchEditRow(row_id, 'checkbox', checkbox ? 'false' : 'true')
                }
            />
            {!isEdit ? (
                <p
                    className={
                        checkbox ? 'subtasks-list__text-through' : 'subtasks-list__text'
                    }
                >
                    {title}
                </p>
            ) : (
                <input
                    autoFocus={isEdit}
                    className="subtasks-list__input"
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.keyCode === 13) {
                            fetchEditRow(row_id, 'Название', value);
                        }
                    }}
                />
            )}

            {(date && !isDate) &&
                <p className="subtasks-list__date">
                    {dayjs(date).format('DD.MM.YYYY')}
                </p>}


            {authorEmail === email &&
                <>
                    {isDate ?
                        <SingleDatePicker
                            date={endDateTask}
                            setDate={(e) => {
                                setEndDateTask(e)
                                fetchEditRow(row_id, 'Дата', e)
                                setIsDate(false)
                            }}
                            minDate={new Date()}
                            style={{
                                minHeight: '26px',
                                minWidth: '120px',
                                maxWidth: '120px'
                            }} />
                        :
                        <ButtonWithIcon
                            size='xs'
                            icon={calendar}
                            onClick={(e) => {
                                setIsDate(true)
                            }}
                        />}

                    <ButtonWithIcon
                        size='xs'
                        icon={isEdit ? check_icon : edit_icon}
                        onClick={(e) => {
                            if (!isEdit) {
                                setIsEdit(true)
                            } else {
                                fetchEditRow(row_id, 'Название', value);
                                setIsEdit(false)
                            }
                        }}
                    />

                    <ButtonWithIcon
                        size='xs'
                        icon={delete_icon}
                        onClick={(e) => {
                            fetchDeleteRow(row_id);
                        }}
                    />
                </>
            }
        </div>
    );
}

export { SubtaskItem }